import { get, post } from "utilities/network";

export const httpFetchActiveSessions = () => {
  return get("admin/bitoshi-hour/fetch?status=active");
};

export const httpFetchInactiveSessions = () => {
  return get("admin/bitoshi-hour/fetch?status=inactive");
};

export const httpFetchCancelledSessions = () => {
  return get("admin/bitoshi-hour/fetch?status=cancelled");
};

export const httpUpdateSession = (sessionId: number, data: any) => {
  return post(`admin/bitoshi-hour/update`, {
    ...data,
    bitoshi_hour_session_id: sessionId,
  });
};

export const httpCancelSession = (sessionId: number) => {
  return post(`admin/bitoshi-hour/update`, {
    bitoshi_hour_session_id: sessionId,
    isCancelled: true,
  });
};
